import styled from 'styled-components'

export const AuthBottomLink = styled.p`
	font-weight: ${({ theme }) => theme.font.medium};
	color: ${({ theme }) => theme.colors.gray600};
`